import { useState } from "react";
import { MainContext } from "../Contexts/MainContext";
import { MobFooter } from "../Layout/Footer/Mob/Footer";
import { Footer } from "../Layout/Footer/Footer";
import { isMobile } from 'react-device-detect';
import { Filter } from "../Filter/Filter";

export function ContentContainer({ children, selectedHeader }) {

    const [lockFooter, setLockFooter] = useState(false);
    const [filterOverlayOpen, setFilterOverlayOpen] = useState(false);

    return (
        <MainContext.Provider value={{ lockFooter, setLockFooter, filterOverlayOpen, setFilterOverlayOpen }}>
            <main style={selectedHeader !== 1 ? { paddingTop: '10.7rem' } : { paddingTop: '0px' }}>{children}</main>
            {filterOverlayOpen && (
                <div className="filter-overlay" style={{ position: 'fixed', inset: 0, zIndex: 9999, background: '#fff' }}>
                    <Filter
                        isOverlay
                        onClose={() => setFilterOverlayOpen(false)}
                    />
                </div>
            )}
            {isMobile ? <MobFooter /> : <Footer />}
        </MainContext.Provider>
    );
}